import React from 'react';
import { Link } from 'react-router-dom';


const Repay = () => {
  return (
    <>
      {/* Custom Cursors */}
      <div className="custom-cursor-one"></div>
      <div className="custom-cursor-two"></div>

      {/* inner-page hero start */}
      <div 
        className="inner-page-hero" 
        style={{ backgroundImage: 'url(/assets/images/background/bg3.png)' }}
      >
        <div className="container">
          <div className="hero-heading-title">
            <h2>Repay</h2>
          </div>
          <ul className="bradcrumb">
            <li><a href="/">Home</a></li>
            <li><Link to="#">Repay</Link></li>
          </ul>
        </div>
      </div>
      {/* inner-page hero end */}

      {/* Repay Section */}
      <section className="repay-section">
        <div className="container">
          
          <div className=" mb-5 text-center">
            <span className="heading-subtitle wow fadeInUp animated">⭐ EASY REPAYMENT</span>
            <h2 className="wow fadeInUp animated">Secure Payment Options</h2>
          </div>

          <div className="row g-4 align-items-stretch">

            {/* Bank Details Card */}
            <div className="col-lg-6 col-md-12">
              <div className="repay-card">
                <div className="text-center mb-4">
                  <span className="repay-icon-box">
                    <i className="flaticon-pay"></i>
                  </span>
                  <h4>
                    Bank Transfer Details
                  </h4>
                  <p className="repay-card-desc">Repay your loan and interest amount through the following Bank Account.</p>
                </div>

                {/* Table Wrapper */}
                <div className="table-responsive">
                  <table className="table table-bordered align-middle mb-0 mt-2 repay-table">
                    <tbody>
                      <tr>
                        <td className="repay-label-col">Company Name</td>
                        <td className="repay-value-primary">
                          Wall Street Merchants Pvt Ltd
                        </td>
                      </tr>
                      <tr>
                        <td className="repay-label-col">Bank Name</td>
                        <td>Wall Street Merchants Pvt Ltd</td>
                      </tr>
                      <tr>
                        <td className="repay-label-col">Account Number</td>
                        <td className="repay-font-mono">10256583723</td>
                      </tr>
                      <tr>
                        <td className="repay-label-col">IFSC Code</td>
                        <td className="repay-font-mono">IDFB0020145</td>
                      </tr>
                      <tr>
                        <td className="repay-label-col">Branch Name</td>
                        <td>NOIDA SECTOR 50 BRANCH</td>
                      </tr>
                      <tr>
                        <td className="repay-label-col">Account Type</td>
                        <td>Current</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>

            {/* QR Code Card */}
            <div className="col-lg-6 col-md-12">
              <div className="repay-card">
                <div className="text-center mb-4">
                  <span className="repay-icon-box">
                    <i className="flaticon-pay"></i>
                  </span>
                  <h4>
                    Scan to Pay
                  </h4>
                  <p className="repay-card-desc">Repay your loan and interest amount through the following QR Code.</p>
                </div>

                <div className="qr-code-wrapper">
                  <img 
                    src="/assets/images/QR.jpg" 
                    className="img-fluid qr-code-img" 
                    alt="Scan QR Code to Pay"
                  />
                </div>
                
              
              </div>
            </div>

          </div>
        </div>
      </section>
    </>
  );
};

export default Repay;